
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/yolo/help",
      function () {
        return require("private-next-pages/yolo/help.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/yolo/help"])
      });
    }
  